'use client';

import { Tooltip, TooltipProps } from '@mui/material';
import React, { useCallback, useState } from 'react';

type ControlledTooltipProps = TooltipProps & { disabled?: boolean; isSelectComponent?: boolean };

const ControlledTooltip = ({
	title,
	placement,
	arrow,
	disabled,
	isSelectComponent = false,
	children,
}: ControlledTooltipProps) => {
	const [open, setOpen] = useState(false);

	const handleSetOpen = useCallback(
		(value: boolean) => {
			if (disabled) return;
			setOpen(value);
		},
		[disabled],
	);

	const child = isSelectComponent ? React.cloneElement(children, { onOpen: () => setOpen(false) }) : children;

	return (
		<Tooltip
			title={title}
			placement={placement}
			arrow={arrow}
			open={open}
			disableHoverListener
			disableFocusListener
		>
			<div
				onMouseEnter={() => handleSetOpen(true)}
				onMouseLeave={() => handleSetOpen(false)}
				onClick={() => handleSetOpen(false)}
			>
				{child}
			</div>
		</Tooltip>
	);
};

export { ControlledTooltip };
